import { render, staticRenderFns } from "./alignmentDetails.vue?vue&type=template&id=1ccfe2fa&scoped=true&"
import script from "./alignmentDetails.vue?vue&type=script&lang=js&"
export * from "./alignmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./alignmentDetails.vue?vue&type=style&index=0&lang=css&"
import style1 from "./alignmentDetails.vue?vue&type=style&index=1&id=1ccfe2fa&lang=less&scoped=true&"
import style2 from "./alignmentDetails.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccfe2fa",
  null
  
)

export default component.exports